(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxAddComputerToNetwork(
    WorkstationListPaging, $http, $filter, toastr, $timeout
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        meta: '=meta',
        callback: '&callback',
        me: '=me'
      },
      templateUrl: 'app/components/sites/addComputerToNetwork/addComputerToNetwork.template.html',
      link: function(scope) {

        scope.selectedWorkstation = null;
        scope.wsPaginationObject = null;
        scope.workstationInScope = false;
        scope.workstationBlank = false;
        

        scope.getWorkstations = function () {
          
          var wsPaginationObject = new WorkstationListPaging();
          wsPaginationObject.pagingCriteria.networks = 'unknown';
          wsPaginationObject.pagingCriteria.active = true;
          scope.wsPaginationObject = wsPaginationObject;
        }

        scope.selectWorkstation = function  (workstation) {
          scope.wsPaginationObject = null;
          scope.selectedWorkstation = workstation;
          scope.workstationBlank = true;
          $timeout(function () {
            scope.workstationInScope = true;
            scope.workstationBlank = false;
          }, 350)
          scope.gateway = scope.selectedWorkstation.info._embedded.adapters[0].gateway;
        }

        scope.addComputer = function () {
          var objectToSend = {
            ip: scope.selectedWorkstation.info._embedded.adapters[0].gateway.ip,
            mac: scope.selectedWorkstation.info._embedded.adapters[0].gateway.mac
          };
          var networkUrl = scope.context._links.self.href + '?updateOthers=true';
          $http.patch(networkUrl, objectToSend, {headers: {"Content-Type": "application/json"}}).then(function(response) {
                toastr.success($filter("translate")("ChangesSaved"));
            }).catch(function(error){});
          scope.callback();
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          var offsetLeft  =  angular.element('.context-content-container')[0].offsetLeft;  
          var offsetTop  =  angular.element('.context-content-container')[0].offsetTop;  
          if (showTip) { 
            position.startX = position.startX - offsetLeft; 
            position.startY = position.startY - offsetTop; 
            switch(tooltipScope) {
              case 'gatewayDetails':
                gatewayTooltip(position, context);
              break;
              case 'AddComputerToNetwork':
                hintTooltip(position);
              break;
            }
          } else {
            scope.clearTooltip();
          }
        }

        function hintTooltip (position) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: 'AddComputerToNetwork',
            type: 'statement'
          }

          scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 20},
            contextMenu: true
          }
        }

        function gatewayTooltip (position, context) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: 'Gateways',
            type: 'gatewayDetails',
            icon: null,
            workstation: context,
          }
          scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 20},
            contextMenu: true
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }


      }
    };
  }

  pxAddComputerToNetwork.$inject = ['WorkstationListPaging', '$http', '$filter', 'toastr', '$timeout'];

  angular
    .module('printix-admin')
    .directive('pxAddComputerToNetwork', pxAddComputerToNetwork);

})();
